export function nullableBooleanToYesNoEmpty(
  val?: boolean | null | undefined
): 'yes' | 'no' | '' {
  if (typeof val === 'boolean') {
    return booleanToYesNo(val);
  }
  return '';
}
function booleanToYesNo(val: boolean) {
  return val ? 'yes' : 'no';
}
